import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Archive", -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Restore", -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* HOISTED */);
const _hoisted_14 = { class: "form-contents" };
const _hoisted_15 = { class: "row" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_18 = { class: "x_panel" };
const _hoisted_19 = { class: "clearfix" };
const _hoisted_20 = { class: "col-xs-12 col-sm-6 col-md-6 bottom10" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tName *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_22 = { class: "invalid-feedback" };
const _hoisted_23 = { class: "col-xs-12 col-sm-12 col-md-3 bottom10" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tRef\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_25 = { class: "col-xs-12 col-sm-12 col-md-3 bottom10" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tType\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_27 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_28 = { class: "clearfix top10" };
const _hoisted_29 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tEmail\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_31 = { class: "invalid-feedback" };
const _hoisted_32 = { class: "col-xs-12 col-sm-6 col-md-3 bottom10" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tPhone\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_34 = { class: "invalid-feedback" };
const _hoisted_35 = { class: "col-xs-12 col-sm-12 col-md-3 bottom10" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tWebsite\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_37 = { class: "clearfix top10" };
const _hoisted_38 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix bottom10" }, [
    /*#__PURE__*/ _createElementVNode("label", { class: "text-muted" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tPhysical Address\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_40 = { class: "clearfix bottom10" };
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tStreet\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_42 = { class: "clearfix bottom10" };
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tSuburb\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_44 = { class: "clearfix bottom10" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tCity / Town\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_46 = { class: "clearfix bottom10" };
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tState\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_48 = { class: "clearfix" };
const _hoisted_49 = { class: "col-xs-12 col-sm-12 col-md-6 pad-left0 no-padding-sm bottom10" };
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tCountry\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_51 = { class: "col-xs-12 col-sm-12 col-md-6 pad-right0 no-padding-sm bottom10" };
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tRegion\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_53 = { class: "clearfix" };
const _hoisted_54 = { class: "col-xs-12 col-sm-12 col-md-6 pad-left0 no-padding-sm bottom10" };
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tCurrency\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_56 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix bottom10" }, [
    /*#__PURE__*/ _createElementVNode("label", { class: "text-muted" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tPostal Address\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_58 = { class: "clearfix bottom10" };
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tPO Box\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_60 = { class: "clearfix bottom10" };
const _hoisted_61 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tSuburb\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_62 = { class: "clearfix bottom10" };
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tCity / Town\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_64 = { class: "clearfix bottom10" };
const _hoisted_65 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tState\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_66 = { class: "clearfix bottom10" };
const _hoisted_67 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tPost Code\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_68 = {
    key: 0,
    class: "clearfix top10"
};
const _hoisted_69 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix col-12 bottom10" }, [
    /*#__PURE__*/ _createElementVNode("label", { class: "text-muted" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tAccount Details\r\n\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_70 = { class: "col-xs-12 col-sm-6 col-md-3 bottom10" };
const _hoisted_71 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tAccount Status\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_72 = { class: "col-xs-12 col-sm-6 col-md-3 bottom10" };
const _hoisted_73 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tAccount Due Date\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_74 = { class: "input-group-append input-group-btn" };
const _hoisted_75 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* HOISTED */);
const _hoisted_76 = { class: "clearfix top10" };
const _hoisted_77 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix col-12 bottom10" }, [
    /*#__PURE__*/ _createElementVNode("label", { class: "text-muted" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tAWS SMS Parameters\r\n\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_78 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tAccess Key\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_80 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_81 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tAccess Key Secret\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_82 = {
    key: 0,
    class: "text-muted"
};
const _hoisted_83 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_84 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tAWS Region\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_85 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_86 = {
    class: "card",
    style: { "height": "132px", "width": "436px", "padding": "2px" }
};
const _hoisted_87 = {
    key: 0,
    class: ""
};
const _hoisted_88 = ["src"];
const _hoisted_89 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_90 = /*#__PURE__*/ _createElementVNode("label", { class: "text-muted" }, "\r\n\t\t\t\t\t\t\t\t\t\tCustom Message to be shown on the Report Footer (max. 50 characters)\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_91 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_92 = { class: "checkbox-wrapper bottom10" };
const _hoisted_93 = { class: "checkbox-wrapper bottom10" };
const _hoisted_94 = { class: "ms-2" };
const _hoisted_95 = /*#__PURE__*/ _createElementVNode("h2", null, "Authentication Methods", -1 /* HOISTED */);
const _hoisted_96 = { class: "ms-2" };
const _hoisted_97 = { class: "checkbox-wrapper bottom10" };
const _hoisted_98 = { class: "checkbox-wrapper bottom10" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_CompanySystemsVue = _resolveComponent("CompanySystemsVue");
    const _component_b_tab = _resolveComponent("b-tab");
    const _component_CompanySystemCategoriesVue = _resolveComponent("CompanySystemCategoriesVue");
    const _component_CompanySitesVue = _resolveComponent("CompanySitesVue");
    const _component_CompanyUsersVue = _resolveComponent("CompanyUsersVue");
    const _component_CompanyContactsVue = _resolveComponent("CompanyContactsVue");
    const _component_ArtificialNotificationAddressesVue = _resolveComponent("ArtificialNotificationAddressesVue");
    const _component_CompanySettingsVue = _resolveComponent("CompanySettingsVue");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_CompanySsoConfigurationVue = _resolveComponent("CompanySsoConfigurationVue");
    const _component_DataCollectorRegisterVue = _resolveComponent("DataCollectorRegisterVue");
    const _component_CompanyEditionVue = _resolveComponent("CompanyEditionVue");
    const _component_b_tabs = _resolveComponent("b-tabs");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_cloud_only = _resolveDirective("cloud-only");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", {
                    class: _normalizeClass({ 'red-text': _ctx.isCompanyArchived })
                }, _toDisplayString(_ctx.pageTitle || 'Missing company name...'), 3 /* TEXT, CLASS */)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.save
                    }, {
                        default: _withCtx(() => [
                            _hoisted_6,
                            _hoisted_7
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createTextVNode(),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "danger",
                        onClick: _ctx.archive
                    }, {
                        default: _withCtx(() => [
                            _hoisted_8,
                            _hoisted_9
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]), [
                        [_vShow, !_ctx.isClientAdministrator && !_ctx.isNewCompany && !_ctx.isCompanyArchived]
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "warning",
                        onClick: _ctx.restore
                    }, {
                        default: _withCtx(() => [
                            _hoisted_10,
                            _hoisted_11
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]), [
                        [_vShow, !_ctx.isClientAdministrator && !_ctx.isNewCompany && _ctx.isCompanyArchived]
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.goBack
                    }, {
                        default: _withCtx(() => [
                            _hoisted_12,
                            _hoisted_13
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_b_tabs, {
                            modelValue: _ctx.activeTab,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((_ctx.activeTab) = $event)),
                            "nav-wrapper-class": "x_title tabs",
                            "content-class": "x_content"
                        }, {
                            default: _withCtx(() => [
                                (!_ctx.isNewCompany)
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "systems",
                                        title: "Systems"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_CompanySystemsVue, {
                                                ref: "systems",
                                                companyId: _ctx.companyId
                                            }, null, 8 /* PROPS */, ["companyId"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (!_ctx.isNewCompany)
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "systemcategories",
                                        title: "System Categories"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_CompanySystemCategoriesVue, { companyId: _ctx.companyId }, null, 8 /* PROPS */, ["companyId"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (!_ctx.isNewCompany)
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "sites",
                                        title: "Sites"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_CompanySitesVue, {
                                                ref: "sites",
                                                companyId: _ctx.companyId,
                                                onOnSiteArchived: _ctx.onSiteArchived
                                            }, null, 8 /* PROPS */, ["companyId", "onOnSiteArchived"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (!_ctx.isNewCompany)
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "users",
                                        title: "Users"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_CompanyUsersVue, {
                                                ref: "users",
                                                companyId: _ctx.companyId
                                            }, null, 8 /* PROPS */, ["companyId"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (!_ctx.isNewCompany && _ctx.isStandardOrHigher)
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "contacts",
                                        title: "Contacts"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_CompanyContactsVue, {
                                                companyId: _ctx.companyId,
                                                onContactsUpdated: _ctx.onContactsUpdated
                                            }, null, 8 /* PROPS */, ["companyId", "onContactsUpdated"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (!_ctx.isNewCompany && _ctx.isStandardOrHigher)
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "notifications",
                                        title: "Notifications"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_ArtificialNotificationAddressesVue, {
                                                ref: "notifications",
                                                companyId: _ctx.companyId
                                            }, null, 8 /* PROPS */, ["companyId"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (!_ctx.isNewCompany && _ctx.isCloudHosting)
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "settings",
                                        title: "Settings"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_CompanySettingsVue, {
                                                ref: "settings",
                                                companyId: _ctx.companyId
                                            }, null, 8 /* PROPS */, ["companyId"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                _createVNode(_component_b_tab, {
                                    key: "details",
                                    title: "Details"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("div", _hoisted_20, [
                                                _hoisted_21,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.nameVal, {
                                                    type: "text",
                                                    modelValue: _ctx.company.companyName,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.company.companyName) = $event)),
                                                    modelModifiers: { trim: true },
                                                    name: "name",
                                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.name },
                                                    maxlength: "100"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _createTextVNode(),
                                                _withDirectives(_createElementVNode("div", _hoisted_22, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a company name\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, _ctx.errors && _ctx.errors.name]
                                                ])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_23, [
                                                _hoisted_24,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    type: "text",
                                                    modelValue: _ctx.company.companyCode,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.company.companyCode) = $event)),
                                                    modelModifiers: { trim: true },
                                                    maxlength: "10"
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_25, [
                                                _hoisted_26,
                                                _createTextVNode(),
                                                _createVNode(_component_multiselect, {
                                                    name: "companyTypeId",
                                                    modelValue: _ctx.companyType,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.companyType) = $event)),
                                                    "track-by": "value",
                                                    label: "text",
                                                    placeholder: _ctx.selectPlaceholder,
                                                    options: _ctx.companyTypes,
                                                    showLabels: false
                                                }, {
                                                    noResult: _withCtx(() => [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.company.primaryAddress)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                _createElementVNode("div", _hoisted_28, [
                                                    _createElementVNode("div", _hoisted_29, [
                                                        _hoisted_30,
                                                        _createTextVNode(),
                                                        _createVNode(_component_b_form_input, _mergeProps(_ctx.emailVal, {
                                                            type: "email",
                                                            modelValue: _ctx.company.primaryAddress.emailAddress,
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.company.primaryAddress.emailAddress) = $event)),
                                                            modelModifiers: { tim: true },
                                                            name: "email",
                                                            class: { 'is-invalid': _ctx.errors && _ctx.errors.email },
                                                            maxlength: "255"
                                                        }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                        _createTextVNode(),
                                                        _withDirectives(_createElementVNode("div", _hoisted_31, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid email\r\n\t\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                            [_vShow, _ctx.errors && _ctx.errors.email]
                                                        ])
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_32, [
                                                        _hoisted_33,
                                                        _createTextVNode(),
                                                        _createVNode(_component_b_form_input, _mergeProps(_ctx.phoneVal, {
                                                            type: "tel",
                                                            modelValue: _ctx.company.primaryAddress.phone,
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.company.primaryAddress.phone) = $event)),
                                                            modelModifiers: { tim: true },
                                                            name: "phone",
                                                            class: { 'is-invalid': _ctx.errors && _ctx.errors.phone },
                                                            maxlength: "100"
                                                        }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                        _createTextVNode(),
                                                        _withDirectives(_createElementVNode("div", _hoisted_34, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid phone number\r\n\t\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                            [_vShow, _ctx.errors && _ctx.errors.phone]
                                                        ])
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_35, [
                                                        _hoisted_36,
                                                        _createTextVNode(),
                                                        _createVNode(_component_b_form_input, {
                                                            type: "url",
                                                            modelValue: _ctx.company.website,
                                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.company.website) = $event)),
                                                            modelModifiers: { tim: true },
                                                            maxlength: "255"
                                                        }, null, 8 /* PROPS */, ["modelValue"])
                                                    ])
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_37, [
                                                    _createElementVNode("div", _hoisted_38, [
                                                        _hoisted_39,
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_40, [
                                                            _hoisted_41,
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_form_input, {
                                                                type: "text",
                                                                modelValue: _ctx.company.primaryAddress.streetAddress1,
                                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.company.primaryAddress.streetAddress1) = $event)),
                                                                modelModifiers: { trim: true },
                                                                maxlength: "150"
                                                            }, null, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_42, [
                                                            _hoisted_43,
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_form_input, {
                                                                type: "text",
                                                                modelValue: _ctx.company.primaryAddress.streetAddress2,
                                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.company.primaryAddress.streetAddress2) = $event)),
                                                                modelModifiers: { trim: true },
                                                                maxlength: "50"
                                                            }, null, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_44, [
                                                            _hoisted_45,
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_form_input, {
                                                                type: "text",
                                                                modelValue: _ctx.company.primaryAddress.streetAddress3,
                                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.company.primaryAddress.streetAddress3) = $event)),
                                                                modelModifiers: { trim: true },
                                                                maxlength: "50"
                                                            }, null, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_46, [
                                                            _hoisted_47,
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_form_input, {
                                                                type: "text",
                                                                modelValue: _ctx.company.primaryAddress.streetAddress4,
                                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.company.primaryAddress.streetAddress4) = $event)),
                                                                modelModifiers: { trim: true },
                                                                maxlength: "50"
                                                            }, null, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_48, [
                                                            _createElementVNode("div", _hoisted_49, [
                                                                _hoisted_50,
                                                                _createTextVNode(),
                                                                _createVNode(_component_multiselect, {
                                                                    name: "countryId",
                                                                    modelValue: _ctx.country,
                                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.country) = $event)),
                                                                    "track-by": "value",
                                                                    label: "text",
                                                                    placeholder: _ctx.selectPlaceholder,
                                                                    options: _ctx.countries,
                                                                    showLabels: false
                                                                }, {
                                                                    noResult: _withCtx(() => [
                                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                    ]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                                            ]),
                                                            _createTextVNode(),
                                                            _createElementVNode("div", _hoisted_51, [
                                                                _hoisted_52,
                                                                _createTextVNode(),
                                                                _createVNode(_component_multiselect, {
                                                                    name: "regionId",
                                                                    modelValue: _ctx.region,
                                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.region) = $event)),
                                                                    "track-by": "value",
                                                                    label: "text",
                                                                    placeholder: _ctx.selectPlaceholder,
                                                                    options: _ctx.regions,
                                                                    showLabels: false
                                                                }, {
                                                                    noResult: _withCtx(() => [
                                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                    ]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                                            ])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_53, [
                                                            _createElementVNode("div", _hoisted_54, [
                                                                _hoisted_55,
                                                                _createTextVNode(),
                                                                _createVNode(_component_multiselect, {
                                                                    name: "currencyId",
                                                                    modelValue: _ctx.currency,
                                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.currency) = $event)),
                                                                    "track-by": "value",
                                                                    label: "text",
                                                                    placeholder: _ctx.selectPlaceholder,
                                                                    options: _ctx.currencies,
                                                                    showLabels: false
                                                                }, {
                                                                    noResult: _withCtx(() => [
                                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                    ]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                                            ])
                                                        ])
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_56, [
                                                        _hoisted_57,
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_58, [
                                                            _hoisted_59,
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_form_input, {
                                                                type: "text",
                                                                modelValue: _ctx.company.primaryAddress.postAddress1,
                                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.company.primaryAddress.postAddress1) = $event)),
                                                                modelModifiers: { trim: true },
                                                                maxlength: "150"
                                                            }, null, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_60, [
                                                            _hoisted_61,
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_form_input, {
                                                                type: "text",
                                                                modelValue: _ctx.company.primaryAddress.postAddress2,
                                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.company.primaryAddress.postAddress2) = $event)),
                                                                modelModifiers: { trim: true },
                                                                maxlength: "50"
                                                            }, null, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_62, [
                                                            _hoisted_63,
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_form_input, {
                                                                type: "text",
                                                                modelValue: _ctx.company.primaryAddress.postAddress3,
                                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.company.primaryAddress.postAddress3) = $event)),
                                                                modelModifiers: { trim: true },
                                                                maxlength: "50"
                                                            }, null, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_64, [
                                                            _hoisted_65,
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_form_input, {
                                                                type: "text",
                                                                modelValue: _ctx.company.primaryAddress.postAddress4,
                                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.company.primaryAddress.postAddress4) = $event)),
                                                                modelModifiers: { trim: true },
                                                                maxlenth: "50"
                                                            }, null, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_66, [
                                                            _hoisted_67,
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_form_input, {
                                                                type: "text",
                                                                modelValue: _ctx.company.primaryAddress.postCode,
                                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.company.primaryAddress.postCode) = $event)),
                                                                modelModifiers: { trim: true },
                                                                maxlength: "50"
                                                            }, null, 8 /* PROPS */, ["modelValue"])
                                                        ])
                                                    ])
                                                ]),
                                                _createTextVNode(),
                                                (_ctx.isAdministrator)
                                                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                        _hoisted_69,
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_70, [
                                                            _hoisted_71,
                                                            _createTextVNode(),
                                                            _createVNode(_component_multiselect, {
                                                                name: "accountStatusOption",
                                                                modelValue: _ctx.accountStatus,
                                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.accountStatus) = $event)),
                                                                "track-by": "value",
                                                                label: "text",
                                                                placeholder: _ctx.selectPlaceholder,
                                                                options: _ctx.accountStatusOptions,
                                                                showLabels: false
                                                            }, null, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_72, [
                                                            _hoisted_73,
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_input_group, { class: "clearfix bottom0" }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_flat_pickr, {
                                                                        class: "form-control",
                                                                        modelValue: _ctx.company.accountDueDate,
                                                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.company.accountDueDate) = $event)),
                                                                        config: _ctx.datePickerConfig,
                                                                        placeholder: "From date",
                                                                        disabled: _ctx.working
                                                                    }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                                                    _createTextVNode(),
                                                                    _createVNode(_component_b_input_group_append, null, {
                                                                        default: _withCtx(() => [
                                                                            _createElementVNode("div", _hoisted_74, [
                                                                                _createVNode(_component_b_button, {
                                                                                    type: "button",
                                                                                    variant: "outline-secondary",
                                                                                    "data-toggle": ""
                                                                                }, {
                                                                                    default: _withCtx(() => [
                                                                                        _hoisted_75
                                                                                    ]),
                                                                                    _: 1 /* STABLE */
                                                                                })
                                                                            ])
                                                                        ]),
                                                                        _: 1 /* STABLE */
                                                                    })
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            })
                                                        ])
                                                    ])), [
                                                        [_directive_cloud_only]
                                                    ])
                                                    : _createCommentVNode("v-if", true),
                                                _createTextVNode(),
                                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_76, [
                                                    _hoisted_77,
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_78, [
                                                        _hoisted_79,
                                                        _createTextVNode(),
                                                        _createVNode(_component_b_form_input, {
                                                            type: "text",
                                                            modelValue: _ctx.company.awsAccessKey,
                                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.company.awsAccessKey) = $event)),
                                                            modelModifiers: { trim: true },
                                                            maxlength: "100"
                                                        }, null, 8 /* PROPS */, ["modelValue"])
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_80, [
                                                        _hoisted_81,
                                                        _createTextVNode(),
                                                        _createVNode(_component_b_form_input, {
                                                            type: "password",
                                                            modelValue: _ctx.company.awsAccessKeySecret,
                                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.company.awsAccessKeySecret) = $event)),
                                                            modelModifiers: { trim: true },
                                                            placeholder: _ctx.isNewCompany ? 'Enter access key secret' : 'Leave blank to keep existing secret',
                                                            maxlength: "100"
                                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
                                                        _createTextVNode(),
                                                        (!_ctx.isNewCompany)
                                                            ? (_openBlock(), _createElementBlock("small", _hoisted_82, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tLeave blank to keep the existing secret (stored encrypted)\r\n\t\t\t\t\t\t\t\t\t\t\t"))
                                                            : _createCommentVNode("v-if", true)
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_83, [
                                                        _hoisted_84,
                                                        _createTextVNode(),
                                                        _createVNode(_component_multiselect, {
                                                            name: "awsRegion",
                                                            modelValue: _ctx.awsRegion,
                                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.awsRegion) = $event)),
                                                            "track-by": "value",
                                                            label: "text",
                                                            placeholder: _ctx.selectPlaceholder,
                                                            options: _ctx.awsRegions,
                                                            showLabels: false
                                                        }, {
                                                            noResult: _withCtx(() => [
                                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                                    ])
                                                ])), [
                                                    [_directive_cloud_only]
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createTextVNode(),
                                _createVNode(_component_b_tab, {
                                    key: "logo",
                                    title: "Reports"
                                }, {
                                    default: _withCtx(() => {
                                        var _a;
                                        return [
                                            _createElementVNode("div", _hoisted_85, [
                                                _createElementVNode("div", _hoisted_86, [
                                                    (_ctx.company.companyLogo && _ctx.company.companyLogo.length != 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                                            _createElementVNode("img", {
                                                                style: { "height": "128px", "width": "432px", "object-fit": "contain" },
                                                                src: _ctx.company.companyLogo
                                                            }, null, 8 /* PROPS */, _hoisted_88)
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("input", {
                                                        ref: "logoInput",
                                                        type: "file",
                                                        class: "",
                                                        style: { "position": "fixed", "top": "-500px", "left": "-500px" },
                                                        accept: "image/*",
                                                        name: "imgUpload",
                                                        onChange: _cache[23] || (_cache[23] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.companyLogoChange && _ctx.companyLogoChange(...args)))
                                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_button, {
                                                        type: "button",
                                                        variant: "primary",
                                                        onClick: _ctx.chooseCompanyLogo
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("Choose an Image")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["onClick"]),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_button, {
                                                        type: "button",
                                                        variant: "primary",
                                                        onClick: _ctx.clearCompanyLogo,
                                                        disabled: (!_ctx.company.companyLogo || ((_a = _ctx.company.companyLogo) === null || _a === void 0 ? void 0 : _a.length) == 0)
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("Clear Logo")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["onClick", "disabled"])
                                                ])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_89, [
                                                _hoisted_90,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    type: "text",
                                                    modelValue: _ctx.company.reportFooterCustomMessage,
                                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.company.reportFooterCustomMessage) = $event)),
                                                    modelModifiers: { trim: true },
                                                    maxlength: "50"
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_91, [
                                                _createElementVNode("div", _hoisted_92, [
                                                    _createVNode(_component_b_form_checkbox, {
                                                        modelValue: _ctx.company.allowClientUsersToScheduleReportsToAllContacts,
                                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_ctx.company.allowClientUsersToScheduleReportsToAllContacts) = $event)),
                                                        size: "lg"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tAllow Client users to schedule reports for all contacts\r\n\t\t\t\t\t\t\t\t\t\t")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["modelValue"])
                                                ])
                                            ])
                                        ];
                                    }),
                                    _: 1 /* STABLE */
                                }),
                                _createTextVNode(),
                                (!_ctx.isNewCompany)
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "twoFactorAuth",
                                        title: "Two Factor Auth"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_93, [
                                                _createVNode(_component_b_form_checkbox, {
                                                    modelValue: _ctx.enable2FA,
                                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.enable2FA) = $event)),
                                                    size: "lg"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tEnable Two Factor Authentication\r\n\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_94, [
                                                _hoisted_95,
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_96, [
                                                    _createElementVNode("div", _hoisted_97, [
                                                        _createVNode(_component_b_form_checkbox, {
                                                            modelValue: _ctx.twoFactorAuthAppAuth,
                                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_ctx.twoFactorAuthAppAuth) = $event)),
                                                            size: "lg",
                                                            disabled: !_ctx.enable2FA
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tApp Authenticator\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["modelValue", "disabled"])
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_98, [
                                                        _createVNode(_component_b_form_checkbox, {
                                                            modelValue: _ctx.twoFactorAuthEmail,
                                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_ctx.twoFactorAuthEmail) = $event)),
                                                            size: "lg",
                                                            disabled: !_ctx.enable2FA
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tEmail Verification\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["modelValue", "disabled"])
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (!_ctx.isNewCompany && _ctx.isSsoEnabledGlobally)
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "sso",
                                        title: "SSO Configuration"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_CompanySsoConfigurationVue, {
                                                ref: "ssoConfig",
                                                companyId: _ctx.companyId,
                                                isCloudHosting: _ctx.isCloudHosting
                                            }, null, 8 /* PROPS */, ["companyId", "isCloudHosting"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (!_ctx.isNewCompany)
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "dataCollectorRegister",
                                        title: "Register Key Files"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_DataCollectorRegisterVue, { companyId: _ctx.companyId }, null, 8 /* PROPS */, ["companyId"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                false
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "edition",
                                        title: "Edition"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_CompanyEditionVue, {
                                                ref: "edition",
                                                companyId: _ctx.companyId
                                            }, null, 8 /* PROPS */, ["companyId"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Working..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
